import { ChangeEvent, useState } from 'react'

import { minCharSearchLimit } from '@/shared/constants/appConstants'
import { useAnalytics } from '@/app/context/AnalyticsContext/AnalyticsContext'

export const useRoundedInputLogic = (
    setSearchValue: (value: string) => void,
    onChange?: (
        event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
    ) => void,
    isCharactersLimit?: boolean
) => {
    const [showTooltip, setShowTooltip] = useState(false)
    const Analytics = useAnalytics()

    const inputOnChange = (
        event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
    ) => {
        event.stopPropagation()
        const newValue = event.target.value
        Analytics?.analyticsLogEvent('search_value', {
            search_value: newValue,
        })
        setSearchValue(newValue)
        onChange && onChange(event)
        setShowTooltip(
            newValue.length > 0 &&
                !!isCharactersLimit &&
                newValue.length < minCharSearchLimit
        )
    }

    return {
        showTooltip,
        inputOnChange,
    }
}
